module.exports = __webpack_public_path__ + "img/two_banner_bg3.ce1ec034.jpg";